module.exports = __webpack_public_path__ + "UX31.png?3c62268da84adc9f8d4b6955e260cbc6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX31.png
// module id = 82
// module chunks = 0